import { styled } from '@mui/material'
import BasicDatagrid from '../../../../components/shared/tables/BasicDatagrid'
const TableRelatorioGestao = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '64.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '64.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '65vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start'
  },

  '& .MuiDataGrid-columnHeaderTitleContainer': {
    width: '100%'
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    width: '100%!important'
  },

  '& .MuiDataGrid-columnHeader:first-of-type .MuiDataGrid-columnHeaderTitle': {
    textAlign: 'left'
  },
  '& .MuiDataGrid-columnHeader:last-of-type .MuiDataGrid-columnHeaderTitle': {
    textAlign: 'left'
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    textAlign: 'center',
    width: '100%'
  }
}))
export default TableRelatorioGestao
